// extracted by mini-css-extract-plugin
export default {"mainMenu":"mainMenu_mainMenu__IYYH3","main":"mainMenu_main__fSFVW","label":"mainMenu_label__tIaG0"};